import { attachEventListeners } from '../../../utility/EventListeners/eventListeners';
import LargeQuery from "../../../utility/large-query/js/large-query";

export default class CombineBox {
    private static queries: any[] = [];
    private static queriesText : any[] = [];

    constructor() {
        this.init();
        this.extractQueryId();
    }

    private init(): void {
        attachEventListeners('.combine-box .js-search-select-all, .expanded:not(.hidden) .js--search-checkbox, .table__mark .js--search-checkbox', 'change', (event) => {
            const target = event.target as HTMLElement;
            const hasSavedSearchTarget = target.dataset.target === "savedSearch"; // select all checkbox
            const hasSavedSearchCheckbox = target.dataset.checkbox === "savedSearch"; // table checkboxes
            if (hasSavedSearchCheckbox || hasSavedSearchTarget) {
                CombineBox.savedSearchHandler(event);
            } else {
                CombineBox.searchHistoryHandler(event);
            }
        });

        attachEventListeners('.combine-box .combine-box__submit', 'click', (event) => {
            const target = event.target as HTMLElement;
            // In this case the query is sent encoded
            let query: string = CombineBox.createQuery(target);
            let isLargeQuery: boolean = LargeQuery.checkIfLargeQuery(query, '/action/combineSearch?AllField=', true);
            CombineBox.combineIds(CombineBox.queries, `${target.dataset.widget ?? ''}`, isLargeQuery);
        });
    }

    private static createQuery($target): string {
        const tabPane = $target.closest('.tab__pane,.profileMain');
        const combineBoxItems = $target.closest('.combine-box__items');
        const checkedElements = tabPane.querySelectorAll('input[type="checkbox"]:checked');
        const operator = combineBoxItems.querySelector('input[type="radio"]:checked').value;

        const relatedQueryElements = [];
        const relatedFacetElements = [];

        checkedElements.forEach(checkbox => {
            const expandedElement = checkbox.closest('tr');
            if (expandedElement) {
                const hiddenQueryElement = expandedElement.querySelector('.hidden.query');
                const hiddenFacetElements = expandedElement.querySelectorAll('.refinements');
                hiddenFacetElements.forEach(facet => {
                    relatedFacetElements.push(`${facet.getAttribute('name')}=${facet.dataset.facetKey}`);
                });
                if (hiddenQueryElement) {
                    relatedQueryElements.push(hiddenQueryElement.textContent);
                }
            }
        });

        //We only encode the query without the facets based on comment #3 LIT-563795
        let query = encodeURIComponent(relatedQueryElements.join(` ${operator} `));
        relatedFacetElements.forEach(facet => {
            query += `&${facet}`;
        });

        return query;
    }

    private static searchHistoryHandler(e): void {
        const combineButton = document.querySelector('.search-history').querySelector<HTMLButtonElement>('.combine-box__submit');
        CombineBox.getQueryIds(e.target);
        combineButton.disabled = document.querySelectorAll('.search-history table input[type="checkbox"]:checked').length <= 1;
    }

    private static savedSearchHandler(e): void {
        const combineButton = document.querySelector('.saved-searches').parentElement.querySelector<HTMLButtonElement>('.combine-box__submit')
        CombineBox.getQueryIds(e.target);
        combineButton.disabled = document.querySelectorAll('.saved-searches .expanded:not(.hidden) input[type="checkbox"]:checked').length <= 1;
    }

    private static getQueryIds(button): void {
        const checkedBoxes = Array.from(document.querySelectorAll('.expanded:not(.hidden) .js--search-checkbox:checked, .search-history .js--search-checkbox:checked'));
        const queryId = (button as HTMLButtonElement).dataset.queryId;

        if (button.classList.contains('js-search-select-all')) {
            if (button.checked) {
                this.queries = checkedBoxes.map((checkBox) => (checkBox as HTMLInputElement).dataset.queryId);
                checkedBoxes.forEach((button: any)=> {
                    const queryText = button.closest('tr').querySelector('[data-query-text-length]') as any;
                    if(queryText) {
                        this.queriesText.push({
                            id: button.dataset.queryId,
                            length: Number(queryText.dataset.queryTextLength) || 0,
                        })
                    }
                })
            } else {
                this.queries = [];
                this.queriesText = [];
            }
        } else if (button.checked) {
            const queryText = button.closest('tr').querySelector('[data-query-text-length]');
            if(queryText) {
                this.queriesText.push({
                    id: queryId,
                    length: Number(queryText.dataset.queryTextLength) || 0,
                })
            }
            this.queries.push(queryId);
        } else {
            const indexToRemove = this.queries.findIndex(query => query === queryId);
            const indexToRemoveText = this.queriesText.findIndex(query => query.id === queryId);

            if (indexToRemove !== -1) {
                this.queries.splice(indexToRemove, 1);
            }

            if (indexToRemoveText !== -1) {
                this.queriesText.splice(indexToRemoveText, 1);
            }
        }
    }

    private static combineIds(ids: string[], widget: string, isLargeQuery: boolean): void {
        const checkbox = document.querySelector('[data-widget="' + widget + '"]').closest('.combine-box').querySelectorAll('.combine-box__operators input:checked')[0] as HTMLInputElement;
        const operatorValue: string = checkbox.value;
        const dynamicParam = widget === "searchHistory" ? "&history=true" : "";
        const staticLink = `/action/combineSearch?queryId=${ids.join('&queryId=')}&operator=${operatorValue}${dynamicParam}`;
        if(this.queriesText.length > 0) {
            var lengthOfQueries = this.queriesText.reduce(function (accumulator, currentValue) {
                return accumulator + currentValue.length;
            }, 0);

            if(lengthOfQueries > 64000) {
                const largeQueryModalBtn = document.querySelector('.large-query-message-btn') as any;
                if(largeQueryModalBtn) {
                    largeQueryModalBtn.click();
                }
                return;
            }
        }
        LargeQuery.redirect(staticLink, isLargeQuery);
    }

    //TODO: to be cleaned up, the query ids should be added through jade
    private extractQueryId() {
        const links = document.querySelectorAll<HTMLAnchorElement>('.expanded:not(.hidden) [data-action-type="saved-search--run"]');

        links.forEach((link) => {
            const match = link.href.match(/runSaved=(\d+)/);
            if (match) {
                const checkbox = link.closest('tr')?.querySelector<HTMLInputElement>('input[type="checkbox"]');
                if (checkbox) {
                    checkbox.dataset.queryId = match[1];
                }
            }
        });
    }
}